// extracted by mini-css-extract-plugin
export default {"customer-logo":"customers_customer-logo__xMyPz","swiper":"customers_swiper__bgINH","titl":"customers_titl__tSzYY"};